export default __webpack_public_path__ + "static/media/WET-Logo.b6b9e9ec.png";